<template>
  <div class="service_order">
    <btHeader class="top_header" @goback="goback"></btHeader>
    <div class="header" :class="[isandroid && 'mt_40']">
      <div class="l">
        <span class="status">{{ comStatus(orderInfo.orderStatus, 0) }}</span>
        <span v-cloak v-if="isCreatedOrder && times" class="desc">{{
          timeFormat(times)
        }}</span>
        <span v-else class="desc">{{
          comStatus(orderInfo.orderStatus, 1)
        }}</span>
      </div>
      <div class="r">
        <img :src="comStatus(orderInfo.orderStatus, 2)" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="item mb_5">
        <span class="fw_500">订单编号</span>
        <span class="flex">
          <span class="fw_500">{{ orderInfo.orderNo }}</span>
          <a
            href="javascript:;"
            class="copy"
            @click="handleCopy(orderInfo.orderNo)"
            >复制</a
          >
        </span>
      </div>
      <div class="item mb_5">
        <span class="fw_500">购买商品</span>
        <span class="fw_500">{{ productName }}</span>
      </div>
      <div class="item spc_item bt">
        <span>绑定车辆</span>
        <span>{{ orderInfo.vehicleName }}</span>
      </div>
      <div class="item spc_item mb_5">
        <span>车架号</span>
        <span>{{ orderInfo.vehicleVin }}</span>
      </div>
      <div class="item spc_item bt">
        <span>总价</span>
        <span>￥{{ twoDecimal(orderInfo.totalAmount) }}</span>
      </div>
      <div class="item spc_item bt">
        <span>优惠券</span>
        <span v-if="orderInfo.couponAmount"
          >-{{ twoDecimal(orderInfo.couponAmount || 0) }}</span
        >
        <span v-else>0</span>
      </div>
      <div class="item spc_item mb_5">
        <span>支付金额</span>
        <span>￥{{ twoDecimal(orderInfo.payAmount) }}</span>
      </div>
    </div>
    <div class="bottom">
      <a v-if="isCreatedOrder" href="javascript:;" @click="handleCancelOrder"
        >取消订单</a
      >
      <a v-if="isCreatedOrder" href="javascript:;" @click="handlePay">支付</a>
      <a v-else class="w_80" :href="tel">联系客服</a>
    </div>
  </div>
</template>
<script>
import {
  orderInfo,
  orderCancelled,
  serviceTel
} from "../../helper/api/service-renewal";
import Clipboard from "clipboard";
import { SUCCESS_CODE } from "../../utils/config";
import orderImg from "../../asset/img/order.png";
import btHeader from "../../components/btHeader";
export default {
  components: { btHeader },
  data() {
    return {
      orderInfo: {},
      tel: "tel:4006666677",
      createTime: "",
      times: "",
      isandroid: "",
      count: 1
    };
  },
  computed: {
    isCreatedOrder() {
      return this.orderInfo.orderStatus === "ORDER_CREATE";
    },
    timeFormat() {
      return function(val) {
        return `剩余${parseInt(val / 60 / 1000)}分${parseInt(
          (val / 1000) % 60
        )}秒`;
      };
    },
    comStatus() {
      return function(val, type) {
        const map = {
          // eslint-disable-next-line no-sparse-arrays
          ORDER_CREATE: ["待支付", , orderImg],
          ORDER_CLOSE: ["已关闭", "您可以服务续费页面重新下单", orderImg],
          ORDER_CANCEL: ["已取消", "期待您的下次购买", orderImg],
          ORDER_COMP: ["已完成", "谢谢惠顾，欢迎下次再来", orderImg]
        };
        return (map[val] || {})[type];
      };
    },
    twoDecimal() {
      return function(val) {
        try {
          return (val / 100).toFixed(2);
        } catch (err) {
          return 0;
        }
      };
    },
    productName() {
      const product =
        (this.orderInfo.orderItemInfoList &&
          this.orderInfo.orderItemInfoList[0]) ||
        {};
      return product.productName ?? "--";
    }
  },
  created() {
    this.$bridge.call("Controller.refreshNav", {
      right: [],
      fullScreen: true,
      hiddenNav: true
    });
    // 机型导航兼容
    if (window.publicMethods.appIsAndroidOrIOS() === "android") {
      this.isandroid = "mt_40";
    } else {
      this.isandroid = "";
    }
  },
  mounted() {
    const serviceRenewalInfo = this.$bridge.call("Storage.serviceRenewalInfo");
    if (!serviceRenewalInfo) {
      this.$toast("获取APP信息失败~~");
      return;
    }
    const {
      // eslint-disable-next-line no-unused-vars
      ssoId,
      // eslint-disable-next-line no-unused-vars
      tokenId,
      // eslint-disable-next-line no-unused-vars
      cVer,
      accessToken,
      brand,
      terminal,
      rs,
      // eslint-disable-next-line no-unused-vars
      avatar,
      // eslint-disable-next-line no-unused-vars
      username,
      // eslint-disable-next-line no-unused-vars
      phone,
      enterpriseId
    } = serviceRenewalInfo || {};
    this.headers = { brand, terminal, accessToken, rs, enterpriseId };
    this.queryOrderDetail();
  },
  methods: {
    goback() {
      this.$router.replace({
        path: "/new-service-renewal"
      });
    },
    getCountDown(time, cut) {
      this.timer = setInterval(() => {
        this.times = 30 * 60 * 1000 - (cut - time) - this.count * 1000;
        this.count++;
        if (this.times <= 0) {
          this.times = 0;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    /**
     * @desc 查询订单页
     * @param {}
     */
    queryOrderDetail() {
      const { orderNo } = this.$route.params;
      orderInfo({ orderNo }, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.orderInfo = data.data || {};
          this.getCountDown(
            this.orderInfo.createTime,
            this.orderInfo.currentTime * 1000
          );
        } else {
          this.$toast(data.description);
        }
      });
    },
    /**
     * @desc 取消订单
     * @param {}
     */
    cancelOrder() {
      const { orderNo } = this.$route.params;
      orderCancelled({ orderNo }, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.$router.replace({
            path: "/new-service-renewal"
          });
        } else this.$toast(data.description);
      });
    },
    /**
     * @desc 获取客服电话
     */
    serviceTel() {
      serviceTel({}, this.headers).then(res => {
        const data = res.data || {};
        if (data.code === SUCCESS_CODE) {
          this.tel = `tel:${data}`;
        }
      });
    },
    // 复制
    handleCopy(orderNo) {
      this.$bridge.call("Storage.copyToClipboard", orderNo);
      const clipboard = new Clipboard(".copy", { text: () => orderNo });
      clipboard.on("success", e => {
        this.$toast("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // eslint-disable-next-line no-undef
        this.$toast("复制失败");
        clipboard.destroy();
      });
    },
    // 支付
    handlePay() {
      const { orderNo, orderStatus, payOrderNo, sign, payUrl } = this.orderInfo;
      // 排除orderNo orderStatus payOrderNo sign为空的情况, payUrl包含订单信息,服务端返回
      if (orderNo && orderStatus && payOrderNo && sign) {
        // 支付成功后跳转页面
        const backUrl = `${window.location.origin}/app-h5-dashboard-haval/new-service-renewal/success`;
        // 支付页header返回页面
        const appBackUrl = `${window.location.origin}/app-h5-dashboard-haval/new-service-renewal/serviceOrder/${orderNo}`;
        // 支付服务
        const jumpUrl = `${payUrl}&cashierStyle=0001&createTime=${new Date().getTime()}&appBackUrl=${encodeURIComponent(
          encodeURIComponent(appBackUrl)
        )}&backUrl=${encodeURIComponent(encodeURIComponent(backUrl))}`;
        window.location.href = jumpUrl;
      } else {
        this.$toast("订单信息缺失~~");
      }
    },
    handleCancelOrder() {
      this.$dialog
        .confirm({
          title: "标题",
          message: "确认取消该订单",
          cancelButtonText: "确认取消",
          confirmButtonText: "暂不取消",
          confirmButtonColor: "#000",
          className: "serviceOrderTips"
        })
        .then(() => {
          // 任何事不做
        })
        .catch(() => {
          this.cancelOrder();
        });
    }
  }
};
</script>
<style lang="scss">
@import "../../asset/scss/mixin.scss";
.serviceOrderTips {
  border-radius: pxTorem(4) !important;
  .van-button {
    height: pxTorem(48);
  }
  .van-dialog__message {
    font-size: pxTorem(14);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #333335;
  }
  .van-dialog__header {
    display: none;
  }
}
.service_order {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: pxTorem(65);
  background: #fff;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  overflow: hidden;
  /deep/ .nav {
    box-shadow: 0px 2px 4px 0px rgba(199, 195, 195, 0.2);
  }
  .header.mt_40 {
    margin-top: pxTorem(70);
  }
  .fw_500 {
    font-weight: 900;
    color: #656566;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .header {
    margin-top: pxTorem(44);
    height: pxTorem(88);
    background: #d9d9d9;
    display: flex;
    justify-content: center;
    .l {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: pxTorem(32);
      .status {
        font-size: pxTorem(18);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333335;
        line-height: pxTorem(44);
      }
      .desc {
        font-size: pxTorem(14);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #656566;
        line-height: pxTorem(17);
      }
    }
    .r {
      width: pxTorem(126);
      img {
        width: 100%;
      }
    }
  }
  .content {
    background: #f5f5f5;
    .item {
      width: 100%;
      height: pxTorem(61);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      font-size: pxTorem(16);
      color: #656566;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: pxTorem(15);
      padding-right: pxTorem(15);
      background: #fff;
      .copy {
        margin-left: pxTorem(10);
        // width: pxTorem(35);
        height: pxTorem(17);
        line-height: pxTorem(17);
        text-align: center;
        font-size: pxTorem(10);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #696d77;
        background: #ececec;
        border-radius: pxTorem(10);
        padding: 0 pxTorem(7);
      }
    }
    .spc_item {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: pxTorem(14);
      color: #696d77;
      height: pxTorem(56);
      margin-bottom: pxTorem(0);
      background: #fff;
    }
    .mb_5 {
      margin-bottom: pxTorem(5);
    }
    .bt {
      border-bottom: pxTorem(1) solid #eee;
    }
  }
  .bottom {
    width: 100%;
    height: pxTorem(85);
    background: #ffffff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    div {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    a {
      width: pxTorem(160);
      line-height: pxTorem(41);
      border-radius: pxTorem(30);
      border: pxTorem(1) solid #2d2d2d;
      text-align: center;
      &:nth-child(1) {
        color: #353333;
      }
      &:nth-child(2) {
        color: #fff;
        background: #2d2d2d;
      }
    }
    .w_80 {
      width: 80%;
    }
  }
}
</style>
